import { constantsData, formFieldNamesData } from "@/data";
import { AsyncDataKeyEnum, FieldTypeEnum } from "@/enums";

const { category } = constantsData.forms.dataSources.categories.moveToParent;

const { category: categoryFieldName } = formFieldNamesData;

export const moveDataSourceCategoryToParentFormData = [
    {
        dataKey: AsyncDataKeyEnum.CATEGORIES,
        description: category.description,
        isAsync: true,
        label: category.label,
        name: categoryFieldName,
        type: FieldTypeEnum.SELECT,
    },
];
